import { useLang } from "@/App";
import { Reveal, BtnPrimario, BtnSecundario } from "./Reveal";

export default function CtaBand() {
  const { t, L } = useLang();
  const c = t.global.cta;
  return (
    <section className="border-t border-lineas bg-sand-deep" data-testid="cta-band">
      <div className="mx-auto flex max-w-[1360px] flex-col gap-8 px-6 py-16 md:px-10 md:py-20 lg:flex-row lg:items-center lg:justify-between">
        <Reveal>
          <p className="pretitulo">{c.pre}</p>
          <h2 className="mt-3 font-serif text-3xl font-light tracking-tight text-ink md:text-4xl">{c.titulo}</h2>
          <p className="mt-3 max-w-xl text-[15px] text-ink-soft">{c.texto}</p>
        </Reveal>
        <Reveal delay={0.12} className="flex flex-col gap-3 sm:flex-row lg:shrink-0">
          <BtnPrimario href={t.reservarLink} testid="cta-whatsapp-btn">{c.btnWa}</BtnPrimario>
          <BtnSecundario href={L("contacto")} testid="cta-contactos-btn">{c.btnContactos}</BtnSecundario>
        </Reveal>
      </div>
    </section>
  );
}